export const templateFields = () => {
  return {
    templateName: {
      value: "",
      error: "",
    },
    category: {
      value: "Private",
    },
    isUserTemplate: {
      value: "",
    },
  };
};
